import React, { useEffect } from "react";

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="legal-modal-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="legal-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-policy-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="legal-modal-header">
          <h2 id="privacy-policy-title">Privacy Policy</h2>
          <button
            type="button"
            className="legal-modal-close"
            onClick={onClose}
            aria-label="Close privacy policy"
          >
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="legal-modal-body">
          <p className="legal-modal-effective">
            <strong>Effective Date:</strong> July 10, 2025
          </p>

          <section className="legal-modal-section">
            <h3>1. Introduction</h3>
            <p>
              At NCG Corporate (&ldquo;we&rdquo;, &ldquo;our&rdquo;, or
              &ldquo;us&rdquo;), your privacy is important to us. This Privacy
              Policy outlines how we collect, use, disclose, and safeguard your
              information when you visit our website www.ncgcorporate.com.
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>2. Information We Collect</h3>
            <p>We may collect the following types of personal information:</p>
            <ul>
              <li>
                <strong>Personal Identification Information:</strong> Name,
                email address, phone number, company name, etc.
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, browser type, pages
                visited, time spent on the website, etc.
              </li>
              <li>
                <strong>Communication Data:</strong> Messages or inquiries you
                submit through contact forms or email.
              </li>
            </ul>
          </section>

          <section className="legal-modal-section">
            <h3>3. How We Use Your Information</h3>
            <p>We may use the information we collect for the following purposes:</p>
            <ul>
              <li>To provide and improve our services</li>
              <li>To respond to inquiries and customer service requests</li>
              <li>
                To send updates, promotional materials, or newsletters (if
                subscribed)
              </li>
              <li>To maintain security and prevent fraud</li>
            </ul>
          </section>

          <section className="legal-modal-section">
            <h3>4. Cookies and Tracking</h3>
            <p>
              Our website may use cookies and similar technologies to enhance
              user experience and gather analytics. You can disable cookies
              through your browser settings.
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>5. Sharing Your Information</h3>
            <p>We do not sell or rent your personal data. However, we may share your data:</p>
            <ul>
              <li>With service providers assisting in website operation</li>
              <li>If required by law or to protect our rights</li>
            </ul>
          </section>

          <section className="legal-modal-section">
            <h3>6. Data Security</h3>
            <p>
              We implement appropriate security measures to protect your personal
              data. However, no method of transmission over the internet is 100%
              secure.
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>7. Your Rights</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access the data we hold about you</li>
              <li>Request corrections or deletions</li>
              <li>Opt out of marketing communications</li>
            </ul>
            <p>
              To exercise these rights, contact us at{" "}
              <a href="mailto:support@ncgcorporate.com">support@ncgcorporate.com</a>
              .
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>8. Third-Party Links</h3>
            <p>
              Our website may contain links to third-party sites. We are not
              responsible for their privacy practices.
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>9. Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Updates will
              be posted on this page with the revised date.
            </p>
          </section>

          <section className="legal-modal-section">
            <h3>10. Contact Us</h3>
            <p>
              If you have questions about this Privacy Policy, please contact us
              at:{" "}
              <a href="mailto:support@ncgcorporate.com">support@ncgcorporate.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
